import { ActionReducerMapBuilder } from '@reduxjs/toolkit'

import { getTikTokFollowWelcomeState } from 'apps/tiktokFollowWelcome/adapter'
import { TikTokFollowWelcomeState } from 'apps/tiktokFollowWelcome/interfaces'
import { NAMESPACE } from 'apps/tiktokFollowWelcome/store/constants'
import { tiktokApi } from 'shared/api/requests/tiktok'
import { createAsyncAction } from 'shared/lib/redux'

export const setTikTokFlow = createAsyncAction(`${NAMESPACE}/setFlow`, async (flowId: string) => {
  const replacedFlowData = await tiktokApi.tikTokFollowReply.replaceFlow({
    body: { flow_ns: flowId },
  })

  return replacedFlowData.data
})

export const setTikTokFlowReducer = (
  builder: ActionReducerMapBuilder<TikTokFollowWelcomeState>,
) => {
  builder.addCase(setTikTokFlow.fulfilled, (state, action) => ({
    ...state,
    ...getTikTokFollowWelcomeState(action.payload),
  }))
}
